import { useEffect, useMemo } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  ScrollRestoration,
  useLocation,
} from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

import { ReactComponent as Rotate } from "./assets/icons/Rotate.svg";

import NotFound from "./screens/404";

import VerifyClientCode from "./screens/VerifyClientCode";
import DermaStart from "./screens/DermaStart";
import SkinAnalyzer from "./screens/SkinAnalyzer";
import DermaResult from "./screens/DermaResult";

const Layout = ({ children }) => {
  const { pathname } = useLocation();
  const isDigitalClinicPath = useMemo(
    () => pathname.startsWith("/digital-clinic"),
    [pathname]
  );

  return (
    <>
      <ScrollRestoration />
      {!isDigitalClinicPath && (
        <div
          className="fixed inset-0 hidden h-screen w-screen lg:flex xs:landscape:flex flex-col items-center justify-center bg-white"
          style={{ zIndex: "999999999" }}
        >
          <Rotate className="flex-shrink-0 h-32 w-36" />
          <p className="mt-6 w-72 text-darkgray text-xl text-center">
            Please rotate your phone to access the application.
          </p>
        </div>
      )}
      {children}
    </>
  );
};

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <>
        <Layout />
        <VerifyClientCode />
      </>
    ),
  },
  {
    path: "derma-start",
    element: (
      <>
        <Layout />
        <DermaStart />
      </>
    ),
  },
  {
    path: "skin-analyzer",
    element: (
      <>
        <Layout />
        <SkinAnalyzer />
      </>
    ),
  },
  {
    path: "derma-result",
    element: (
      <>
        <Layout />
        <DermaResult />
      </>
    ),
  },
  {
    path: "*",
    element: (
      <Layout>
        <NotFound />
      </Layout>
    ),
  },
]);

const App = () => {
  useEffect(() => {
    AOS.init();
  }, []);
  return <RouterProvider router={router} />;
};

export default App;
